import {
  BUTTON_VARIANTS,
  IconList,
  IconMapPin,
  VisuallyHidden,
} from "@puregym/ui";
import labels from "../labels";
import styled from "styled-components";
import { Button } from "@puregym/ui";
import { DisplayType } from "../../constants/ui";

const ToggleWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;

const StyledToggleButton = styled(Button)`
  padding: ${({ theme }) => theme.spacing.halfSpacing};
  border: ${({ theme }) => `1px solid ${theme.colors.opacities.darkSubtle}}`};
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);

  &:not(:disabled) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.colors.opacities.dark};
    }

    &:focus {
      box-shadow: ${({ theme }) =>
        `${theme.boxShadows.focus}, 0 0 2px 0 rgba(0, 0, 0, 0.15)`};
    }
  }

  &[aria-pressed="true"] {
    background-color: ${({ theme }) => theme.colors.opacities.darkSubtle};
    color: ${({ theme }) => theme.colors.secondary.main};
    box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.15);

    &:focus {
      background-color: ${({ theme }) => theme.colors.opacities.darkSubtle};
      box-shadow: ${({ theme }) =>
        `${theme.boxShadows.focus}, inset 0 0 3px 0 rgba(0, 0, 0, 0.15)`};
    }
  }

  &:first-child {
    border-inline-end-width: 0;
    border-end-end-radius: 0;
    border-start-end-radius: 0;
  }

  &:last-child {
    border-inline-start-width: 0;
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
`;

const ToggleButton = ({
  displayType,
  toggleDisplayType,
}: {
  displayType: DisplayType;
  toggleDisplayType: (displayType: DisplayType) => void;
}) => (
  <ToggleWrapper role="group" aria-label={labels.gymDisplayToggle}>
    <StyledToggleButton
      isActive={displayType === "list"}
      variant={BUTTON_VARIANTS.PLAIN}
      aria-label={labels.listViewTitle}
      aria-pressed={displayType === "list"}
      onClick={() => toggleDisplayType("list")}
    >
      <IconList title={labels.listView} aria-hidden />
      <VisuallyHidden>{labels.listView}</VisuallyHidden>
    </StyledToggleButton>
    <StyledToggleButton
      variant={BUTTON_VARIANTS.PLAIN}
      aria-label={labels.mapViewTitle}
      aria-pressed={displayType === "map"}
      onClick={() => toggleDisplayType("map")}
    >
      <IconMapPin title={labels.mapView} aria-hidden />
      <VisuallyHidden>{labels.mapView}</VisuallyHidden>
    </StyledToggleButton>
  </ToggleWrapper>
);

export default ToggleButton;
